import React from "react";
import FirstAnimatedContainer from "./FirstAnimatedContainer";
import Card from "./Card";

function Taller (){
    const imageUrl='https://raw.githubusercontent.com/LTuhay/rosa-recicla/master/public/assets/taller.jpg';
    const text= 'Este taller nació con la intención de crear un espacio para el desarrollo de actividades artesanales, partiendo de la utilización de materiales reciclados.'
    const additionalText= '';

    return (
        <div>
            <FirstAnimatedContainer animationDuration="2s">
                <Card image={imageUrl} title='Sobre el taller' text={text} additionalText={additionalText} imagePosition='left' />
            </FirstAnimatedContainer>
        </div>
    )
}

export default Taller;